import { LogoutAuth } from 'domain/usecases/auth/remote';
import {
  NotFound,
  BadRequestError,
  Forbidden,
  UnexpectedError,
  BadGateway,
} from 'domain/errors';
import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import 'infra/global/variables';

export class RemoteLogoutAuth implements LogoutAuth {
  private readonly url: string;

  private readonly httpClient: HttpClient<LogoutAuth.Model>;

  constructor(url: string, httClient: HttpClient<LogoutAuth.Model>) {
    this.url = url;
    this.httpClient = httClient;
  }

  logout = async (params: LogoutAuth.Params): Promise<LogoutAuth.Model> => {
    const httpResponse = await this.httpClient.request({
      url: this.url,
      method: 'patch',
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
      case HttpStatusCode.created:
      case HttpStatusCode.accepted:
      case HttpStatusCode.noContent:
        return httpResponse.body;
      case HttpStatusCode.badRequest:
        throw new BadRequestError();
      case HttpStatusCode.notFound:
        throw new NotFound();
      case HttpStatusCode.unauthorized:
        throw new Forbidden();
      case HttpStatusCode.badGateway:
        throw new BadGateway();
      default:
        throw new UnexpectedError();
    }
  };
}
